import { createAxiosClient } from "@ntg/component-library/utilities";
import { useQuery } from "@tanstack/react-query";
import { ISalesOrderHeader } from "../../declarations/SalesOrderHeader";

const getSalesOrderHeader = async (
    orderID: number,
): Promise<ISalesOrderHeader> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.get<ISalesOrderHeader>(
        `/SalesOrderHeader/GetSalesOrderHeader/${orderID}`,
    );
    return response.data;
};

export const useGetSalesOrderHeader = (orderID: number) =>
    useQuery<ISalesOrderHeader>({
        enabled: orderID > 0,
        queryFn: () => getSalesOrderHeader(orderID),
        queryKey: ["GetSalesOrderHeader", orderID],
        refetchOnWindowFocus: false,
        retry: false,
    });
